// import React, { useEffect, useState } from "react";
// import { Breadcrumb, Button, Card, Form, Image, Modal } from "react-bootstrap";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { useForm } from "react-hook-form";
// import { z } from "zod";
// import { Table } from "ka-table";
// import { fetch } from "../../utils";
// import "ka-table/style.css";
// import { BASE_URL } from "../../config";

// const bootstrapChildComponents = {
//   table: {
//     elementAttributes: () => ({
//       className: "table table-striped table-hover table-bordered ",
//     }),
//   },
//   tableHead: {
//     elementAttributes: () => ({
//       className: "thead-dark",
//     }),
//   },
//   noDataRow: {
//     content: () => "No Data Found",
//   },
// };
// const AdminCategory = () => {
//   const [categoryData, setCategoryData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [formLoading, setFormLoading] = useState(false);
//   const [formMessage, setFormMessage] = useState(null);
//   const [show, setShow] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [showedit, setShowEdit] = useState(false);
//   const handleEditClose = () => setShowEdit(false);
//   const [donateHeadsData, setDonateHeadsData] = useState({
//     list: [],
//     loading: false,
//   });

//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setShow(true);
//     setFormMessage(null);
//     reset();
//   };

//   const setCategoryDisplayStatus = async (category_id, display_status) => {
//     try {
//       const response = await fetch(
//         "category/update-dispaly-status",
//         "POST",
//         {
//           category_id: category_id,
//           display_status: display_status ? 0 : 1,
//         },
//         null
//       );

//       if (response.status === 200) {
//         const { success } = response.data;
//         if (success === true) {
//           getCategory();
//         }
//       }
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         alert(error.response.data.message);
//       } else if (error.message) {
//         alert(error.message);
//       } else {
//         alert("Something went wrong.");
//       }
//     }
//   };

//   const getCategory = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("category/all", "GET", null, null);
//       if (response.status === 200) {
//         const { success, data } = response.data;
//         if (success === true) {
//           const categorys = data.categorys;
//           const tableData = await categorys.map((category, index) => {
//             return {
//               id: index + 1,
//               category_name: category.category_name,
//               category_description: category.category_description,
//               category_thumbnail: category.category_thumbnail,
//               category_id: category.category_id,
//               display_status: {
//                 display_status: category.display_status,
//                 category_id: category.category_id,
//               },
//             };
//           });
//           setCategoryData(tableData);
//         } else {
//           setCategoryData([]);
//         }
//       } else {
//         setCategoryData([]);
//       }
//     } catch (error) {
//       setCategoryData([]);
//     } finally {
//       setLoading(false);
//     }
//   };



//   // const schema = z.object({
//   //   category_name: z.string().required("Category name is required"),
//   //   category_description: z.string().required("Category description is required"),
//   //   category_thumbnail: z.object({
//   //     name: z.string().required("Image is required"),
//   //     size: z.number().max(5242880, "Image size should be less than 5MB"),
//   //     type: z.string().regex(/\.(jpg|jpeg|png)$/i, "Invalid image format"),
//   //   }),
//   // });


//   // const schema = z.object({
//   //   category_name: z.string().min(1, { message: "category name is required." }),
//   //   category_description: z
//   //     .string()
//   //     .min(1, { message: "category description is required." }),
//   // });



//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm(
//     {
//       // resolver: zodResolver(schema),
//       // defaultValues: {
//       //   category_name: "",
//       //   category_description: "",
//       // },
//     }
//   );


//   const handleAddCategory = async (formData) => {
//     try {
//       setFormLoading(true);
//       setFormMessage(
//         <font color="blue">
//           <b>Loading....</b>
//         </font>
//       );
//       setFormLoading(true);
//       const categoryData = new FormData();
//       categoryData.append("category_name", formData.category_name);
//       categoryData.append("category_description", formData.category_description);
//       const response = await fetch("category/add", "POST", categoryData, null);
//       if (response.status === 201) {
//         const { success, message } = response.data;
//         if (success === true) {
//           setFormMessage(
//             <font color="green">
//               <b>{message}</b>
//             </font>
//           );
//           handleClose();
//           reset();
//           getCategory();
//           return true;
//         }
//       }
//       setFormMessage(
//         <font color="red">
//           <b>{response.message}</b>
//         </font>
//       );
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         setFormMessage(
//           <font color="red">
//             <b>{error.response.data.message}</b>
//           </font>
//         );
//       } else if (error && error.message) {
//         setFormMessage(
//           <font color="red">
//             <b>{error.message}</b>
//           </font>
//         );
//       } else {
//         setFormMessage(
//           <font color="red">
//             <b>Something went wrong.</b>
//           </font>
//         );
//       }
//     } finally {
//       setFormLoading(false);
//     }
//   };

//   useEffect(() => {
//     getCategory();
//   }, []);

//   const [selectedHead, setSelectedHead] = useState(null);
//   // const handleEditShow = (category_id) => {
//   //   const selectedHead = categoryData.find(editCat => editCat.category_id === category_id);
//   //   console.log("selectedHead", selectedHead)
//   //   setSelectedHead(selectedHead);
//   //   setShowEdit(true);
//   //   console.log("selectedHead", selectedHead)

//   // };

//   // const handleChange = (event) => {
//   //   const { name, value } = event.target;
//   //   setSelectedHead(prevState => ({
//   //     ...prevState,
//   //     [name]: value
//   //   }));
//   // };

//   // const handleUpdateDonationHead = async () => {
//   //   try {
//   //     const formData = new FormData();
//   //     formData.append("category_name", selectedHead.category_name);
//   //     formData.append("category_description", selectedHead.category_description);
//   //     formData.append("category_thumbnail", selectedHead.category_thumbnail);

//   //     const response = await fetch(`${BASE_URL}/category/categories/${selectedHead.category_id}`, "POST", formData, null);


//   //     if (response.status === 200) {
//   //       // Handle success
//   //       console.log('Category updated successfully');
//   //       handleEditClose();
//   //       // Optionally, you can update the category list here
//   //       getCategory();
//   //     } else {
//   //       // Handle error
//   //       console.error('Failed to update category');
//   //     }
//   //   } catch (error) {
//   //     // Handle error
//   //     console.error('Error updating category', error);
//   //   }
//   // };


//   return (
//     <div className="container-fluid">
//       <Breadcrumb className="p-2">
//         <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
//         <Breadcrumb.Item active>Category</Breadcrumb.Item>
//       </Breadcrumb>

//       {/* Modal */}
//       <Modal show={show} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title>Add Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form encType="multipart/form-data" onSubmit={handleSubmit(handleAddCategory)}>
//             <Form.Group className="mb-3" >
//               <Form.Label>Category</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter Category"
//                 {...register("category_name", { required: true })}
//               />
//               {/* <p className="text-danger">{errors.category_name?.message}</p> */}
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Category Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 placeholder="Enter Category Description"
//                 {...register("category_description", { required: true })}
//               />
//               {/* <p className="text-danger">
//                 {errors.category_description?.message}
//               </p> */}
//             </Form.Group>

//             {/* <Form.Group className="mb-3" >
//               <Form.Label>Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 placeholder="image"
//                 {...register("category_thumbnail", { required: true })}
//               />
//             </Form.Group> */}

//             <Modal.Footer>

//               <Button variant="primary" type="submit" disabled={formLoading}>
//                 Add
//               </Button>

//               <Button variant="secondary" onClick={handleClose}>
//                 Close
//               </Button>
//             </Modal.Footer>
//           </Form>
//           <p class="text-danger"> {formMessage}</p>
//         </Modal.Body>
//       </Modal>

//       {/* Modal */}

//       <section className="content">
//         <div className="container-fluid">
//           <Card>
//             <Card.Header>
//               <h4>
//                 Category
//                 <button
//                   className="btn btn-xs btn-primary pull-right"
//                   onClick={handleShow}
//                 >
//                   Add
//                 </button>
//               </h4>
//             </Card.Header>
//             <Card.Body>
//               <div className="row">
//                 <div className="co-sm-12">
//                   <input
//                     type="search"
//                     value={searchText}
//                     onChange={(event) => {
//                       setSearchText(event.currentTarget.value);
//                     }}
//                     className="top-element pull-right m-2"
//                   />
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-sm-12">
//                   <Table
//                     loading={{
//                       enabled: loading,
//                       text: "Loading data",
//                     }}
//                     columns={[
//                       {
//                         key: "id",
//                         title: "Sr.No.",
//                         width: "5%",
//                       },
//                       {
//                         key: "category_name",
//                         title: "Category",
//                         width: "40%",
//                       },
//                       {
//                         key: "category_description",
//                         title: "Category Description",
//                         width: "40%",
//                       },
//                       // {
//                       //   key: "category_thumbnail",
//                       //   title: "Image",
//                       //   width: "9%",
//                       // },
//                       // {
//                       //   key: "category_id",
//                       //   title: "Edit",
//                       //   width: "9%",
//                       // },
//                       {
//                         key: "display_status",
//                         title: "Active",
//                         style: { textAlign: "center" },
//                         width: "10%",
//                       },
//                     ]}

//                     format={({ column, value }) => {

//                       if (column.key === "id") {
//                         return `${value}.`;
//                       }

//                       // if (column.key === "category_thumbnail") {
//                       //   return (
//                       //     <a href={value} target="_blank" rel="noopener noreferrer">
//                       //       <Image src={value} thumbnail style={{ maxWidth: "70%" }} />
//                       //     </a>
//                       //   );
//                       // }

//                       // if (column.key === "category_id") {
//                       //   return (
//                       //     <button class="btn" onClick={() => handleEditShow(value)} target="_blank" rel="noopener noreferrer">
//                       //       <i class="fa fa-pencil-square-o text-danger" aria-hidden="true" style={{ fontSize: "20px" }} />

//                       //     </button>
//                       //   );
//                       // }

//                       if (column.key === "display_status") {
//                         return (
//                           <Form.Check
//                             type="switch"
//                             id="custom-switch"
//                             checked={value.display_status ? true : false}
//                             onChange={() => {
//                               setCategoryDisplayStatus(
//                                 value.category_id,
//                                 value.display_status ? true : false
//                               );
//                             }}
//                           />
//                         );
//                       }
//                     }}

//                     data={categoryData}
//                     search={({
//                       searchText: searchTextValue,
//                       rowData,
//                       column,
//                     }) => {
//                       if (column.key === "passed") {
//                         return (
//                           (searchTextValue === "false" && !rowData.passed) ||
//                           (searchTextValue === "true" && rowData.passed)
//                         );
//                       }
//                     }}
//                     rowKeyField={"id"}
//                     searchText={searchText}
//                     noData={{
//                       text: "No Data Found",
//                     }}
//                     childComponents={bootstrapChildComponents}
//                   />
//                 </div>
//               </div>
//             </Card.Body>
//             <Card.Footer></Card.Footer>
//           </Card>
//         </div>
//       </section>


// {/* 
//       <Modal
//         show={showedit}
//         onHide={handleEditClose}
//         backdrop="static"
//         keyboard={false}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Donation Heads</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form >
//             <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
//               <Form.Label>Category Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter Category Name"
//                 value={selectedHead ? selectedHead.category_name : ''}
//                 onChange={(e) => setSelectedHead({ ...selectedHead, category_name: e.target.value })}
//               />
//             </Form.Group>

//             <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
//               <Form.Label>Category Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 placeholder="Enter Category Description"
//                 value={selectedHead ? selectedHead.category_description : ''}
//                 onChange={(e) => setSelectedHead({ ...selectedHead, category_description: e.target.value })}
//               />
//             </Form.Group>

//             <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
//               <Form.Label>Category Thumbnail</Form.Label>
//               <Form.Control
//                 type="file"
//                 onChange={(e) => setSelectedHead({ ...selectedHead, category_thumbnail: e.target.files[0] })}
//               />
//             </Form.Group>



//             <Image src="http://localhost:1721/public/data/category_thumbnail/27/20240306T101232160Z027657.jpg" alt="" className="w-25" />
//           </Form>
//           <Form.Control
//             type="text"
//             hidden={true}
//             placeholder="Enter Attribute Value Type"
//           />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} size="sm">
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             disabled={formLoading}
//             size="sm"
//             onClick={handleUpdateDonationHead}
//           >
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal> */}
//     </div>
//   );
// };

// export default AdminCategory;



import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Form, Image, Modal } from "react-bootstrap";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Table } from "ka-table";
import { fetch } from "../../utils";
import "ka-table/style.css";
import { BASE_URL } from "../../config";

const bootstrapChildComponents = {
  table: {
    elementAttributes: () => ({
      className: "table table-striped table-hover table-bordered ",
    }),
  },
  tableHead: {
    elementAttributes: () => ({
      className: "thead-dark",
    }),
  },
  noDataRow: {
    content: () => "No Data Found",
  },
};
const AdminCategory = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [formMessage, setFormMessage] = useState(null);
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showedit, setShowEdit] = useState(false);
  const handleEditClose = () => setShowEdit(false);
  const [donateHeadsData, setDonateHeadsData] = useState({
    list: [],
    loading: false,
  });

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormMessage(null);
    reset();
  };


  const setCategoryDisplayStatus = async (category_id, display_status) => {
    try {
      const response = await fetch(
        "category/update-dispaly-status",
        "POST",
        {
          category_id: category_id,
          display_status: display_status ? 0 : 1,
        },
        null
      );

      if (response.status === 200) {
        const { success } = response.data;
        if (success === true) {
          getCategory();
        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(error.response.data.message);
      } else if (error.message) {
        alert(error.message);
      } else {
        alert("Something went wrong.");
      }
    }
  };






  const getCategory = async () => {
    try {
      setLoading(true);
      const response = await fetch("category/all", "GET", null, null);
      if (response.status === 200) {
        const { success, data } = response.data;
        if (success === true) {
          const categorys = data.categorys;
          const tableData = await categorys.map((category, index) => {
            return {
              id: index + 1,
              category_name: category.category_name,
              category_description: category.category_description,
              category_thumbnail: category.category_thumbnail,
              category_id: category.category_id,
              display_status: {
                display_status: category.display_status,
                category_id: category.category_id,
              },

            };
          });
          setCategoryData(tableData);
        } else {
          setCategoryData([]);
        }
      } else {
        setCategoryData([]);
      }
    } catch (error) {
      setCategoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm(
    {
      // resolver: zodResolver(schema),
      // defaultValues: {
      //   category_name: "",
      //   category_description: "",
      // },
    }
  );


  const handleAddCategory = async (formData) => {
    try {
      setFormLoading(true);
      setFormMessage(
        <font color="blue">
          <b>Loading....</b>
        </font>
      );
      setFormLoading(true);
      const categoryData = new FormData();
      categoryData.append("category_name", formData.category_name);
      categoryData.append("category_description", formData.category_description);
      categoryData.append("category_thumbnail", formData.category_thumbnail[0]); // Access the first file from the FileList

      const response = await fetch("category/add", "POST", categoryData, null);
      if (response.status === 201) {
        const { success, message } = response.data;
        if (success === true) {
          setFormMessage(
            <font color="green">
              <b>{message}</b>
            </font>
          );
          handleClose();
          reset();
          getCategory();
          return true;
        }
      }
      setFormMessage(
        <font color="red">
          <b>{response.message}</b>
        </font>
      );
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setFormMessage(
          <font color="red">
            <b>{error.response.data.message}</b>
          </font>
        );
      } else if (error && error.message) {
        setFormMessage(
          <font color="red">
            <b>{error.message}</b>
          </font>
        );
      } else {
        setFormMessage(
          <font color="red">
            <b>Something went wrong.</b>
          </font>
        );
      }
    } finally {
      setFormLoading(false);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  const [selectedHead, setSelectedHead] = useState(null);
  // const handleEditShow = (category_id) => {
  //   const selectedHead = categoryData.find(editCat => editCat.category_id === category_id);
  //   console.log("selectedHead", selectedHead)
  //   setSelectedHead(selectedHead);
  //   setShowEdit(true);
  //   console.log("selectedHead", selectedHead)

  // };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setSelectedHead(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };

  // const handleUpdateDonationHead = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("category_name", selectedHead.category_name);
  //     formData.append("category_description", selectedHead.category_description);
  //     formData.append("category_thumbnail", selectedHead.category_thumbnail);

  //     const response = await fetch(`${BASE_URL}/category/categories/${selectedHead.category_id}`, "POST", formData, null);


  //     if (response.status === 200) {
  //       // Handle success
  //       console.log('Category updated successfully');
  //       handleEditClose();
  //       // Optionally, you can update the category list here
  //       getCategory();
  //     } else {
  //       // Handle error
  //       console.error('Failed to update category');
  //     }
  //   } catch (error) {
  //     // Handle error
  //     console.error('Error updating category', error);
  //   }
  // };


  return (
    <div className="container-fluid">
      <Breadcrumb className="p-2">
        <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item active>Category</Breadcrumb.Item>
      </Breadcrumb>

      {/* Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form encType="multipart/form-data" onSubmit={handleSubmit(handleAddCategory)}>
            <Form.Group className="mb-3" >
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Category"
                {...register("category_name", { required: true })}
              />
              {/* <p className="text-danger">{errors.category_name?.message}</p> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Category Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Category Description"
                {...register("category_description", { required: true })}
              />
              {/* <p className="text-danger">
                {errors.category_description?.message}
              </p> */}
            </Form.Group>

            <Form.Group className="mb-3" >
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                placeholder="image"
                {...register("category_thumbnail", { required: true })}
              />
            </Form.Group>

            <Modal.Footer>

              <Button variant="primary" type="submit" disabled={formLoading}>
                Add
              </Button>

              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
          <p class="text-danger"> {formMessage}</p>
        </Modal.Body>
      </Modal>

      {/* Modal */}

      <section className="content">
        <div className="container-fluid">
          <Card>
            <Card.Header>
              <h3 className="font-femily">
                Category
                <button
                  className="btn btn-xs btn-primary pull-right"
                  onClick={handleShow}
                >
                  Add Category
                </button>
              </h3>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="co-sm-12">
                  <input
                    type="search"
                    value={searchText}
                    onChange={(event) => {
                      setSearchText(event.currentTarget.value);
                    }}
                    className="top-element pull-right m-2"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Table
                    loading={{
                      enabled: loading,
                      text: "Loading data",
                    }}
                    columns={[
                      {
                        key: "id",
                        title: "Sr.No.",
                        width: "5%",
                      },
                      {
                        key: "category_name",
                        title: "Category",
                        width: "40%",
                      },
                      {
                        key: "category_description",
                        title: "Category Description",
                        width: "40%",
                      },
                      {
                        key: "category_thumbnail",
                        title: "Image",
                        width: "9%",
                      },
                      // {
                      //   key: "category_id",
                      //   title: "Edit",
                      //   width: "9%",
                      // },
                      {
                        key: "display_status",
                        title: "Active",
                        style: { textAlign: "center" },
                        width: "10%",
                      },
                     

                    ]}

                    format={({ column, value }) => {

                      if (column.key === "id") {
                        return `${value}.`;
                      }

                      if (column.key === "category_thumbnail") {
                        return (
                          <a href={value} target="_blank" rel="noopener noreferrer">
                            <Image src={value} thumbnail style={{ maxWidth: "70%" }} />
                          </a>
                        );
                      }

                      // if (column.key === "category_id") {
                      //   return (
                      //     <button class="btn" onClick={() => handleEditShow(value)} target="_blank" rel="noopener noreferrer">
                      //       <i class="fa fa-pencil-square-o text-danger" aria-hidden="true" style={{ fontSize: "20px" }} />

                      //     </button>
                      //   );
                      // }

                      if (column.key === "display_status") {
                        return (
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={value.display_status ? true : false}
                            onChange={() => {
                              setCategoryDisplayStatus(
                                value.category_id,
                                value.display_status ? true : false
                              );
                            }}
                          />
                        );
                      }
                    }}

                    data={categoryData}
                    search={({
                      searchText: searchTextValue,
                      rowData,
                      column,
                    }) => {
                      if (column.key === "passed") {
                        return (
                          (searchTextValue === "false" && !rowData.passed) ||
                          (searchTextValue === "true" && rowData.passed)
                        );
                      }
                    }}
                    rowKeyField={"id"}
                    searchText={searchText}
                    noData={{
                      text: "No Data Found",
                    }}
                    childComponents={bootstrapChildComponents}
                  />
                </div>
              </div>
            </Card.Body>
            <Card.Footer></Card.Footer>
          </Card>
        </div>
      </section>


      {/* 
      <Modal
        show={showedit}
        onHide={handleEditClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Donation Heads</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Category Name"
                value={selectedHead ? selectedHead.category_name : ''}
                onChange={(e) => setSelectedHead({ ...selectedHead, category_name: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Category Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Category Description"
                value={selectedHead ? selectedHead.category_description : ''}
                onChange={(e) => setSelectedHead({ ...selectedHead, category_description: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
              <Form.Label>Category Thumbnail</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setSelectedHead({ ...selectedHead, category_thumbnail: e.target.files[0] })}
              />
            </Form.Group>

    
            
            <Image src="http://localhost:1721/public/data/category_thumbnail/27/20240306T101232160Z027657.jpg" alt="" className="w-25" />
          </Form>
          <Form.Control
            type="text"
            hidden={true}
            placeholder="Enter Attribute Value Type"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} size="sm">
            Close
          </Button>
          <Button
            variant="primary"
            disabled={formLoading}
            size="sm"
            onClick={handleUpdateDonationHead}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default AdminCategory;


